import { Injectable, OnDestroy } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { feedbackSubmit } from '../model/feedbackSubmit';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Setting } from '../../common/settings';
import url from 'src/settings.json';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import { AuthService } from 'src/app/auth/service/auth.service';


@Injectable({
  providedIn: 'root'
})
export class FeedbackService implements OnDestroy {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: 'my-auth-token'
    })
  };
  organisationSubscriber?: Subscription;
  setting: Setting = url;
  currentOrganisation: any;
  currentUser:any;
  public feedbackEmitter = new BehaviorSubject<any>(false);

  constructor(private readonly httpClient: HttpClient,
   private readonly oAuthService: OAuthService,
   private readonly AuthService:AuthService,
   private readonly organisationService: OrganisationService) {
    console.log(this.AuthService.claims);
    this.currentUser=this.AuthService.upn;
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    console.log(this.currentOrganisation);
  }

  public submitFeedback(feedbackRequest: feedbackSubmit): Observable<feedbackSubmit> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', 'application/json').set('Authorization', `Bearer ${token}`)
    return this.httpClient.post<feedbackSubmit>(`${url}/api/feedback`, feedbackRequest, this.httpOptions)
      .pipe(
      //catchError(this.handleError('addRequest'))
    );
  }

  public getFeedbacks(responseId: number): Observable<any> {
    const token = this.oAuthService.getAccessToken();
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<any>(`${url}/api/feedback/` + responseId, { headers: headers })
  }
  ngOnDestroy(): void {
    this.organisationSubscriber?.unsubscribe();
  }
}

